import Page from "@app/components/pageTypes/Page/Page"

import { MyParadiseTransponderModal } from "@app/modals/MyParadise/MyParadiseTransponderModal/MyParadiseTransponderModal"
import "./styles.css"

export default function AppTransponderPage() {
	return (
		<Page className="appdataPage">
			<MyParadiseTransponderModal />
		</Page>
	)
}
